export const useWeightSplitter = () => {
  const weights = {
    'andacredito.es': {},
    'andacredito.mx': {},
    'cashspace.ph': {},
    'cashspace.pl': {},
    'cashspace.vn': {},
    'crezu.co': {},
    'crezu.es': {},
    'crezu.kz': {},
    'crezu.lk': {},
    'crezu.mx': {},
    'crezu.ph': {},
    'crezu.pl': {},
    'crezu.ro': {},
    'crezu.vn': {},
    'fastpera.com': {},
    'finteres.es': {},
    'finteres.mx': {},
    'helptowallet.com': {},
    'mytenge.com': {},
    'mytindung.com': {},
    'opinomia.com': {},
    'pera-ph.com': {},
    'pezetita.com': {},
    'pezetita.mx': {},
    'prestamobravo.com': {},
    'sieudong.com': {},
    'tarjetasenlinea.es': {},
    'localhost': {
      'CV-1': {
        weight: 0.33,
        feedURL: '/offers',
        sub2: 'feed',
      },
      'CV-2': {
        weight: 0.33,
        feedURL: '/offers2',
        sub2: 'feed',
      },
      'CV-3': {
        weight: 0.33,
        feedURL: '/offers3',
        sub2: 'feed',
      }
    },
  }

  const getFeedData = (hostname) => {
    if (!weights[hostname] || Object.keys(weights[hostname]).length === 0) {
      return {
        feedURL: '',
        sub2: 'feed',
        expFlow: ''
      };
    }

    const variants = weights[hostname];

    const totalWeight = Object.values(variants).reduce((sum, variant) => sum + variant.weight, 0);
    const random = Math.random() * totalWeight;
    let cumulativeWeight = 0;

    for (const key in variants) {
      cumulativeWeight += variants[key].weight;
      if (random <= cumulativeWeight) {
        return {
          feedURL: variants[key].feedURL,
          sub2: variants[key].sub2,
          expFlow: key
        };
      }
    }
  };

  return {
    getFeedData
  }
}



// WEBPACK FOOTER //
// ./src/utils/offersWeightsSplitter.js